"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LemonRemixScripts = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@remix-run/react");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const jotai_1 = require("jotai");
const atom_1 = require("../../atom");
function dedupe(array) {
    return [...new Set(array)];
}
const StrictCSPScripts = () => {
    const { manifest, serverHandoffString } = (0, react_2.useContext)(react_1.UNSAFE_RemixContext);
    const { router } = (0, react_2.useContext)(react_router_dom_1.UNSAFE_DataRouterContext);
    const { matches } = (0, react_2.useContext)(react_router_dom_1.UNSAFE_DataRouterStateContext);
    const navigation = (0, react_1.useNavigation)();
    const [isHydrated, setIsHydrated] = (0, react_2.useState)(false);
    const cspScripts = (0, jotai_1.useAtomValue)(atom_1.$CSPScripts);
    (0, react_2.useEffect)(() => {
        setIsHydrated(true);
    }, []);
    const initialScripts = (0, react_2.useMemo)(() => {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("script", { id: "remix-server-handoff", type: "application/json", suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: serverHandoffString || '"{}"' } }), (0, jsx_runtime_1.jsx)("script", { id: "remix-route-modules", type: "application/json", dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            manifest: manifest.url,
                            modules: matches.map((match) => [match.route.id, manifest.routes[match.route.id].module]),
                            entry: manifest.entry.module,
                        }) || '"{}"',
                    } }), (0, jsx_runtime_1.jsx)("script", { src: cspScripts['remix-server-handoff'] }), (0, jsx_runtime_1.jsx)("script", { type: "module", async: true, src: cspScripts['remix-route-modules'] })] }));
    }, []);
    const nextMatches = (0, react_2.useMemo)(() => {
        if (navigation.location) {
            const matches = (0, react_router_dom_1.matchRoutes)(router.routes, navigation.location);
            if (!matches) {
                throw new Error(`No routes match path "${navigation.location.pathname}"`);
            }
            return matches;
        }
        return [];
    }, [navigation.location, router.routes]);
    const routePreloads = matches
        .concat(nextMatches)
        .map((match) => {
        const route = manifest.routes[match.route.id];
        return (route.imports || []).concat([route.module]);
    })
        .flat(1);
    const preloads = isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("link", { rel: "modulepreload", href: manifest.entry.module }), dedupe(preloads).map((path) => ((0, jsx_runtime_1.jsx)("link", { rel: "modulepreload", href: path }, path))), initialScripts] }));
};
const LemonRemixScripts = () => {
    const { disableInlineScripts } = (0, jotai_1.useAtomValue)(atom_1.$RenderConfig);
    if (disableInlineScripts) {
        return (0, jsx_runtime_1.jsx)(StrictCSPScripts, {});
    }
    return (0, jsx_runtime_1.jsx)(react_1.Scripts, {});
};
exports.LemonRemixScripts = LemonRemixScripts;
